import { styled } from "sharedUI/styles";

export const RadioGroupStyle = styled.ul`
    display: flex;
    flex-direction: column;

    input {
        appearance: auto;
    }

    input.with-subtitle {
        align-self: flex-start;
        margin-top: 2px;
    }

    label {
        position: relative;
        display: flex;
        padding: 8px 0;

        cursor: pointer;

        align-items: center;
        > :first-child {
            margin-right: 8px;
        }

        > input[type="radio"] {
            width: 16px;
            height: 16px;
            opacity: 0;
            cursor: pointer;

            + .dummy {
                position: absolute;
                top: 8px;
                left: 0;
                width: 16px;
                height: 16px;
                border-radius: 8px;
                border: solid 1px ${p => p.theme.n500A};

                &.disabled {
                  border-color: ${p => p.theme.n300A};
                }

                &.flat {
                    border: none;
                    background-color: ${p => p.theme.n300A};
                }

                &.flat.disabled {
                    background-color: ${p => p.theme.n100A};
                }
            }
            &:checked + .dummy {
                border: solid 4px ${p => p.theme.b400};
                background-color: transparent;
            }
        }


        .radio-group-labels {
            display: flex;
            flex-direction: column;
            font-size: 13px;
            font-weight: 300;

            .radio-group-subtitle {
                font-size: 12px;
                color: ${p => p.theme.fgColorMedium};
                margin-top: 4px;
                margin-bottom: 6px;
            }
        }
    }
`;
